<template>
	<!-- 充值二维码支付页面 -->
	<div class="qrcode_wrap">
		<!-- 顶部导航栏 -->
		<div class="red_top_bg">
			<div class="back_left" @click="$router.push('/invest')"></div>
			<div class="big_tit">{{ data.payment.name }}</div>
		</div>

		<!-- 充值金额卡片 -->
		<div class="amount_card">
			<div class="amount_label">充值金额</div>
			<div class="amount_value">{{ money }}</div>
			<!-- <div class="amount_tip" v-if="actualAmount">{{ actualAmount }}</div> -->
		</div>

		<!-- 二维码支付区域 -->
		<div class="qrcode_card">
			<div class="pay_title">
				<img class="pay_icon" :src="data.payment.logo" v-if="data.payment.logo" />
				<span>{{ data.payment.name }}</span>
			</div>

			<!-- <div class="qrcode_box" @click="previewQrcode">
				<img class="qrcode_img" :src="data.payment.qrcode" alt="" />
			</div> -->

			<!-- <div class="scan_tip">{{ $t('invest_qrcode.scanQRcode') }}</div> -->

			<!-- USDT 钱包地址信息 -->
			<div class="wallet_info" v-if="data.payment.type == 1">
				<div class="wallet_label">{{ $t('invest_qrcode.walletAddress') }}</div>
				<div class="wallet_address">{{ data.payment.address }}</div>
			</div>
		</div>

		<!-- 复制地址按钮 -->
		<div class="copy_btn" v-if="data.payment.type == 1" @click="copyAddress"
			v-clipboard="() => data.payment.address" v-clipboard:success="copy">
			<van-icon name="description" />
			<span>{{ $t('invest_qrcode.copyWalletAddress') }}</span>
		</div>

		<!-- 上传支付凭证 -->
		<div class="upload_card">
			<div class="upload_title">
				<span class="required">*</span>
				<span>上传支付凭证</span>
			</div>
			<div class="upload_area">
				<van-uploader v-model="fileList" :max-count="1" :max-size="10 * 1024 * 1024" @oversize="onOversize"
					:after-read="afterRead" :before-read="beforeRead" :deletable="true">
					<template #default>
						<div class="upload_content" v-if="fileList.length === 0">
							<van-icon name="photograph" class="upload_icon" />
							<span class="upload_text">点击上传支付凭证</span>
						</div>
					</template>
				</van-uploader>
			</div>
			<div class="upload_tip">请上传支付成功截图作为凭证（支持jpg/png格式，最大10MB）</div>
		</div>

		<!-- 提交按钮 -->
		<div class="submit_btn" @click="submitBtn">
			{{ $t('utils.submit') }}
		</div>

		<!-- 温馨提示 -->
		<div class="tips_box">
			<div class="tips_title">温馨提示</div>
			<div class="tips_content">点击提交后,需要等待1小时左右,才能到账</div>
		</div>
	</div>
</template>

<script>
/**
 * 充值二维码支付页面组件
 * 展示支付二维码，支持复制钱包地址和提交支付申请
 * 使用van-uploader上传支付凭证，参考addcountUsdt组件实现
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import Api from "../../interface/index";
import Clipboard from 'v-clipboard';
import { Icon, Uploader, Toast, ImagePreview, Dialog } from 'vant';
import axios from 'axios';

Vue.use(Clipboard);
Vue.use(Icon);
Vue.use(Uploader);
Vue.use(Dialog);

export default {
	name: "invest_qrcode",
	/**
	 * 组件数据
	 * @returns {Object} 数据对象
	 * @returns {Object} data - 支付配置数据
	 * @returns {number|string} money - 充值金额
	 * @returns {string} actualAmount - 实际到账金额显示文本
	 * @returns {boolean} submitLoading - 提交按钮加载状态
	 * @returns {Array} fileList - van-uploader文件列表
	 * @returns {string} voucherUrl - 上传成功后的凭证图片URL
	 */
	data() {
		return {
			data: {
				payment: {},
				orderId: ''
			},
			money: 0,
			actualAmount: '',
			submitLoading: false,
			fileList: [],
			voucherUrl: '',
		};
	},
	created() {
		this.$parent.footer('user', false);
	},
	mounted() {
		this.money = this.$route.query.money || 0;
		this.start();
	},
	methods: {
		/**
		 * 获取充值支付配置
		 * 从后端获取支付方式信息和订单ID
		 */
		start() {
			Fetch('/user/recharge_type', {
				money: this.$route.query.money || "",
				id: this.$route.query.id || ""
			}).then((r) => {
				this.data = r.data;
				this.changeAmount();
			});
		},
		/**
		 * 提交充值申请
		 * 验证凭证URL并提交，成功后跳转到钱包页面
		 */
		submitBtn() {
			// 防止重复提交
			if (this.submitLoading) return;

			// 验证是否上传了支付凭证
			if (!this.voucherUrl) {
				this.$toast({
					message: '请先上传支付凭证',
					position: 'middle',
					forbidClick: true,
					background: 'rgba(0, 0, 0, 0.7)',
					icon: 'warning-o',
					// className: 'toast-black-text',
				});
				return;
			}

			this.submitLoading = true;

			// 提交充值申请
			Fetch("/user/recharge_apply", {
				id: this.data.orderId,
				voucher: this.voucherUrl
			}).then((r) => {
				this.submitLoading = false;
				if (r.code == 1) {
					this.$toast({
						background: "#07c160",
						message: this.$t('invest_qrcode.submittedSuccessfully'),
					});
					this.$router.replace("/moneybag");
				} else {
					this.$toast({
						message: r.info || r.message || '提交失败，请重试',
						position: 'bottom',
					});
				}
			}).catch((error) => {
				this.submitLoading = false;
				console.error('提交失败:', error);
				this.$toast({
					message: '网络错误，请重试',
					position: 'bottom',
				});
			});
		},
		/**
		 * 预览二维码图片
		 * 使用Vant ImagePreview组件全屏展示二维码
		 */
		previewQrcode() {
			if (this.data.payment && this.data.payment.qrcode) {
				ImagePreview({
					images: [this.data.payment.qrcode],
					closeable: true,
					closeOnPopstate: true,
				});
			}
		},
		/**
		 * 复制钱包地址
		 * 复制USDT钱包地址到剪贴板
		 */
		copyAddress() {
			// 复制功能由 v-clipboard 指令处理
		},
		/**
		 * 复制成功回调
		 * 显示复制成功提示
		 */
		copy() {
			this.$toast({
				className: "toastName",
				message: this.$t('invest_qrcode.copySucceeded'),
			});
		},
		/**
		 * 文件大小超限回调
		 * 当上传文件超过10MB时显示提示
		 * @param {Object} file - 文件对象
		 */
		onOversize(file) {
			Dialog.alert({
				message: '图片大小不能超过10MB',
			}).then(() => {});
		},
		/**
		 * 文件上传前验证
		 * 验证文件格式是否为jpg/png
		 * @param {Object} file - 文件对象
		 * @returns {boolean} 是否允许上传
		 */
		beforeRead(file) {
			if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
				this.$toast('仅支持jpg/png格式图片');
				return false;
			}
			return true;
		},
		/**
		 * 文件读取完成后上传
		 * 将文件上传到服务器，获取远程URL
		 * @param {Object} file - 包含file属性的文件对象
		 */
		afterRead(file) {
			// 设置上传状态
			file.status = 'uploading';
			file.message = '上传中...';

			// 创建FormData对象
			let formData = new FormData();
			formData.append('language', this.$i18n.locale || "zh_cn");
			formData.append('file', file.file);
			formData.append('token', localStorage.getItem('token'));

			// 显示加载提示
			Toast.loading({
				forbidClick: true,
				duration: 20000,
				message: '上传中...'
			});

			// 上传到服务器
			axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then((r) => {
				Toast.clear();
				if (r.data.code === 1) {
					// 上传成功，保存远程URL
					file.status = 'done';
					file.message = '';
					this.voucherUrl = r.data.data;
					this.$toast({
						message: '上传成功',
						position: 'bottom',
					});
				} else {
					// 上传失败
					file.status = 'failed';
					file.message = '上传失败';
					this.voucherUrl = '';
					if (r.data.info) {
						this.$toast(r.data.info);
					} else {
						this.$toast('上传失败，请重试');
					}
				}
			}).catch((error) => {
				// 网络错误
				Toast.clear();
				file.status = 'failed';
				file.message = '上传失败';
				this.voucherUrl = '';
				console.error('上传失败:', error);
				this.$toast('网络错误，请重试');
			});
		},
		/**
		 * 计算实际到账金额
		 * 根据汇率计算并格式化显示金额
		 */
		changeAmount() {
			if (!this.data.payment || !this.data.payment.rate) return;

			let num = 2;
			const rate = this.data.payment.rate;
			const mark = this.data.payment.mark || '';

			if (this.data.payment.type == 1) {
				// USDT类型，根据汇率大小调整小数位数
				if (rate > 10000) {
					num = 8;
				} else if (rate > 1000) {
					num = 6;
				} else if (rate > 10) {
					num = 4;
				}
				this.actualAmount = "≈" + (this.money / rate).toFixed(num) + " " + mark;
			} else {
				// 其他支付方式
				this.actualAmount = "≈" + mark + (this.money / rate).toFixed(num);
			}
		}
	}
};
</script>

<style lang="less" scoped>
/**
 * 充值二维码支付页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.qrcode_wrap {
	min-height: 100vh;
	background-color: #f5f5f5;
	padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
	height: 168px;
	background-image: url(../images/user/moneybag/bg.png);
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 10;
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

/* 充值金额卡片 */
.amount_card {
	position: relative;
	margin-top: 74px;
	margin-left: 15px;
	margin-right: 15px;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	border-radius: 12px;
	padding: 25px 20px;
	text-align: center;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	z-index: 11;

	.amount_label {
		font-size: 14px;
		color: rgba(255, 255, 255, 0.9);
		margin-bottom: 10px;
	}

	.amount_value {
		font-size: 36px;
		font-weight: bold;
		color: #fff;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.amount_tip {
		font-size: 14px;
		color: rgba(255, 255, 255, 0.85);
		margin-top: 8px;
		background: rgba(255, 255, 255, 0.2);
		display: inline-block;
		padding: 4px 12px;
		border-radius: 20px;
	}
}

/* 二维码支付卡片 */
.qrcode_card {
	margin: 20px 15px;
	background: #fff;
	border-radius: 12px;
	padding: 25px 20px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	text-align: center;

	.pay_title {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;

		.pay_icon {
			width: 28px;
			height: 28px;
			margin-right: 10px;
			border-radius: 6px;
		}

		span {
			font-size: 18px;
			font-weight: 600;
			color: #333;
		}
	}

	.qrcode_box {
		width: 220px;
		height: 220px;
		margin: 0 auto;
		padding: 10px;
		background: #fff;
		border: 2px solid #f0f0f0;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			border-color: #ff5252;
			box-shadow: 0 4px 12px rgba(255, 82, 82, 0.2);
		}

		.qrcode_img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	.scan_tip {
		font-size: 14px;
		color: #999;
		margin-top: 15px;
	}

	/* 钱包地址信息 */
	.wallet_info {
		margin-top: 20px;
		padding-top: 20px;
		border-top: 1px dashed #eee;

		.wallet_label {
			font-size: 13px;
			color: #999;
			margin-bottom: 8px;
		}

		.wallet_address {
			font-size: 13px;
			color: #333;
			word-break: break-all;
			line-height: 1.6;
			padding: 10px 15px;
			background: #f8f8f8;
			border-radius: 6px;
		}
	}
}

/* 复制按钮 */
.copy_btn {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 15px;
	padding: 14px;
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
		background: #f9f9f9;
	}

	.van-icon {
		font-size: 18px;
		color: #ff5252;
		margin-right: 8px;
	}

	span {
		font-size: 15px;
		color: #333;
		font-weight: 500;
	}
}

/* 上传支付凭证卡片 */
.upload_card {
	margin: 20px 15px;
	padding: 20px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.upload_title {
		font-size: 15px;
		color: #333;
		font-weight: 600;
		margin-bottom: 15px;
		display: flex;
		align-items: center;

		.required {
			color: #ff5252;
			margin-right: 4px;
			font-size: 16px;
		}
	}

	.upload_area {
		width: 100%;
		min-height: 150px;
		border: 2px dashed #e0e0e0;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;
		overflow: hidden;

		&:hover {
			border-color: #ff5252;
			background: #fff5f5;
		}

		.upload_content {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 30px;

			.upload_icon {
				font-size: 48px;
				color: #ccc;
				margin-bottom: 12px;
			}

			.upload_text {
				font-size: 14px;
				color: #999;
			}
		}
	}

	.upload_tip {
		font-size: 12px;
		color: #999;
		margin-top: 10px;
		text-align: center;
	}
}

/* van-uploader组件样式覆盖 */
/deep/ .van-uploader {
	width: 100%;

	.van-uploader__wrapper {
		width: 100%;
		justify-content: center;
	}

	.van-uploader__input-wrapper {
		width: 100%;
		min-height: 150px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-uploader__upload {
		width: 100%;
		min-height: 150px;
		margin: 0;
		background: transparent;
		border: none;
	}

	.van-uploader__preview {
		width: 100%;
		margin: 0;

		.van-uploader__preview-image {
			width: 100%;
			max-height: 300px;
			border-radius: 4px;
		}

		.van-uploader__preview-delete {
			width: 28px;
			height: 28px;
			background: rgba(0, 0, 0, 0.5);
			border-radius: 50%;
			top: 8px;
			right: 8px;

			&:hover {
				background: rgba(255, 82, 82, 0.8);
			}

			.van-uploader__preview-delete-icon {
				font-size: 18px;
			}
		}
	}

	.van-uploader__mask {
		border-radius: 4px;
	}
}

/* 提交按钮 */
.submit_btn {
	margin: 20px 15px;
	height: 48px;
	line-height: 48px;
	text-align: center;
	background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	border-radius: 24px;
	box-shadow: 0 4px 15px rgba(255, 82, 82, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;

	&:active {
		transform: scale(0.98);
		box-shadow: 0 2px 8px rgba(255, 82, 82, 0.4);
	}
}

/* 温馨提示 */
.tips_box {
	margin: 20px 15px;
	padding: 15px;
	background: #fff;
	border-radius: 10px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

	.tips_title {
		font-size: 14px;
		color: #333;
		font-weight: 600;
		margin-bottom: 10px;
		display: flex;
		align-items: center;

		&::before {
			content: '';
			display: inline-block;
			width: 3px;
			height: 14px;
			background: #ff5252;
			border-radius: 2px;
			margin-right: 8px;
		}
	}

	.tips_content {
		font-size: 13px;
		color: #666;
		line-height: 1.8;
	}
}

/* 自定义Toast样式 */
/deep/ .toast-black-text .van-toast__text {
	color: #000000 !important;
}
</style>
